import Contact from "../components/contact";
import Footer from "../components/footer";
import Header from "../components/header";

const ContactPage = () => {
  return (
    <>
      <Header />
      <Contact />
      <Footer />
    </>
  );
};

export default ContactPage;
